import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import {
  Button,
  Modal,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  OutlinedInput,
  InputLabel,
  FormControl,
  Checkbox,
} from "@mui/material";

export default function DetailsPart({
  open,
  handleClose,
  setOpen,
  mode,
  detailsData,
  setDetailsData,
}) {
    const [localDetails, setLocalDetails] = React.useState("");

    React.useEffect(() => {
      if (open && mode) {
        setLocalDetails(detailsData[mode] || "");
      }
    }, [open, mode, detailsData]);

    const handleSave = () => {
      setDetailsData((prev) => ({
        ...prev,
        [mode]: localDetails,
      }));

      setOpen(false);
    };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "40%", md: "40%", lg: "50%", xl: "50%" },

          position: "absolute",
          left: { xs: "2%", sm: "35%", md: "35%", lg: "25%", xl: "25%" },

          top: "20%",
        }}
      >
        <Box sx={{ backgroundColor: "#C0BFFF", mb: 2 }}>
          <CloseIcon
            sx={{
              fontSize: "28px",
              float: "right",
              m: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              setOpen(false);
            }}
          />
          <Typography
            sx={{
              p: "10px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              fontWeight: 500,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            color="primary"
          >
            Total Amount
          </Typography>
        </Box>
        <Grid
          sx={{
            p: "10px",
          }}
        >
          <TextField
            fullWidth
            size="small"
            label="Details"
            value={localDetails}
            onChange={(e) => setLocalDetails(e.target.value)}
          />
          <Button
            variant="contained"
            sx={{
              width: "100%",
              mt: "10px",
            }}
            onClick={handleSave}
          >
            {" "}
            Save
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
}
